export const LAT_LNG_PRECISION = 6;
